import { Flex, Icon, Text } from '@cad-arc';
import { EntityTypes, MergedEntityTypes, Person } from '../../../../../fr-entity-panels/types';
import {
    getPersonTitle,
    getPersonDisplayWeightOrHeight,
    getEntityDescription,
    getHeightInDisplayedFormat,
    getPhoneNumberInDisplayedFormat,
} from '../helpers';
import { CommonSize } from '../../../../../common/helpers/utils';
import { MasterPersonLinkButton } from '../../../../../panels/entity-panels/forms/persons/entity-panel-form-person-card-controls';

export function PersonCardTileFields({
    person,
    index,
    entityType,
    size = 'sm',
}: {
    person: Person;
    index: number;
    entityType: EntityTypes | MergedEntityTypes;
    size?: CommonSize;
}) {
    const {
        involvementTypeOption,
        involvementTypeOther,
        phoneNumber,
        phoneExtension,
        race,
        sex,
        eyeColor,
        hairColor,
        fullName,
        weight,
        weightMax,
        weightMin,
        height,
        heightMax,
        heightMin,
    } = person;

    const displayWeight = getPersonDisplayWeightOrHeight({
        value: weight,
        max: weightMax,
        min: weightMin,
    });

    const displayHeight = getPersonDisplayWeightOrHeight({
        value: getHeightInDisplayedFormat(height),
        max: getHeightInDisplayedFormat(heightMax),
        min: getHeightInDisplayedFormat(heightMin),
    });

    return (
        <>
            <Flex margin={0} padding={0} alignItems="center" gap="5px">
                <Text
                    fontWeight="bold"
                    fontSize={size == 'sm' ? 'md' : size}
                    style={{ wordBreak: 'break-word' }}
                >
                    {getPersonTitle({ fullName, index, entityType })}
                </Text>
                {Object.values(MergedEntityTypes).includes(entityType as MergedEntityTypes) && (
                    <Icon icon="Merge" />
                )}
                <MasterPersonLinkButton
                    isPersisted={person.isPersisted}
                    masterPersonId={person.eventMasterPersonData?.id}
                />
            </Flex>
            {involvementTypeOption?.label && (
                <Text fontSize={size} color="tertiary" style={{ marginTop: 0 }}>
                    {`${involvementTypeOption.label}${
                        involvementTypeOther ? ` (${involvementTypeOther})` : ''
                    }`}
                </Text>
            )}
            {phoneNumber && (
                <Text
                    fontWeight="semibold"
                    fontSize={size}
                    color="tertiary"
                    style={{ marginTop: 0 }}
                >
                    {`${getPhoneNumberInDisplayedFormat(phoneNumber)}${
                        phoneExtension ? ` ext. ${phoneExtension}` : ''
                    }`}
                </Text>
            )}
            <Text fontSize={size} color="tertiary" style={{ marginTop: 0 }}>
                {getEntityDescription([
                    race?.label,
                    sex?.label,
                    displayHeight,
                    displayWeight ? `${displayWeight} lbs` : null,
                    eyeColor?.label ? `${eyeColor.label} eyes` : null,
                    hairColor?.label ? `${hairColor.label} hair` : null,
                ])}
            </Text>
        </>
    );
}
